import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuOptionsService } from '@shared/services/menu-option-service';
import { PortalMenuOptionsService } from '@shared/services/portal-menu-options.service';

@Component({
  selector: 'terminal-operator-management',
  imports: [RouterOutlet],
  templateUrl: './terminal-operator-management.html',
  styleUrl: './terminal-operator-management.scss',
})
export class TerminalOperatorManagement {
  private menuOptionsService = inject(MenuOptionsService);
  private portalMenuOptionsService = inject(PortalMenuOptionsService);

  ngOnInit(): void {
    this.menuOptionsService.clearMenuOptions();
    this.menuOptionsService.setOptions(
      this.portalMenuOptionsService.getTerminalManagementOptions(),
    );
  }

  ngOnDestroy() {
    this.menuOptionsService.setOptions([]);
  }
}
